/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Pause_Reason_NameInputs */

const en_tables_pause_reasons_pause_reason_name = /** @type {(inputs: Tables_Pause_Reasons_Pause_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_tables_pause_reasons_pause_reason_name = /** @type {(inputs: Tables_Pause_Reasons_Pause_Reason_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Tables_Pause_Reasons_Pause_Reason_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_pause_reason_name = /** @type {((inputs?: Tables_Pause_Reasons_Pause_Reason_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Pause_Reason_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_pause_reason_name(inputs)
	return de_tables_pause_reasons_pause_reason_name(inputs)
});